import React, { useEffect } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { isNullOrEmpty } from '../../utils/util';
import loading from '../../assets/images/loading.gif';

const SelectItem = (props) => {
    let inputSelectRef;

    useEffect(() => {
        const data = {};
        props.data.map((item) => data[item.text] = null);

        M.Autocomplete.init(inputSelectRef, {
            data,
            limit: props.limit ?? 20,
            minLength: props.minLength ?? 1,
            onAutocomplete: (value) => {
                value = props.data.find((item) => item.text?.trim() === value.trim());
                if (props.onChangeData && value) {
                    var element = {
                        target: {
                            name: props.id,
                            value: value.id,
                            type: "text"
                        }
                    }
                    props.onChangeData(props.changeEvent ? element : value.id);
                }
            }
        });

        const defaultValue = props.data.find((item) => item.id === props.defaultValue);
        if (defaultValue) {
            inputSelectRef.value = defaultValue.text;
        }

        if (!defaultValue && !isNullOrEmpty(props.defaultValue) && props.textDefault) {
            inputSelectRef.value = props.defaultValue;
        }

        if (props.data?.length > 0 && props.minLength === 0 && props.focus) {
            inputSelectRef.focus();
            try {
                document.getElementById(props.id)?.click();
            } catch (error) {
                console.log(error)
            }
        } else {
            inputSelectRef.blur();
        }

        // eslint-disable-next-line
    }, [props.data?.length]);

    useEffect(() => {
        if (!isNullOrEmpty(props.value) || !isNullOrEmpty(props.defaultValue)) {
            const documentClass = inputSelectRef.labels[0];
            if (documentClass && documentClass.className && !documentClass.className.includes('active')) {
                inputSelectRef.labels[0].className = `${inputSelectRef.labels[0].className} active`;
            }

            if (documentClass && documentClass.className === '') {
                inputSelectRef.labels[0].className = 'active';
            }
        }
        // eslint-disable-next-line
    }, [props.value, props.defaultValue]);

    const onChange = (event) => {
        if (props.onChange) {
            props.onChange(props.changeEvent ? event : event.target.value);
        }
    }

    return (
        <>
            <input
                required={props.required}
                id={props.id}
                name={props.name}
                disabled={props.disabled}
                onChange={(event) => onChange(event)}
                ref={(el) => inputSelectRef = el}
                type="text"
                autoComplete="off"
                maxLength={props.maxLength}
                className="autocomplete" />
            {props.isLoading && (
                <div
                    style={{
                        position: "absolute",
                        right: "10px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none"
                    }}
                >
                    <img
                        src={loading}
                        alt="loading"
                        style={{ width: "20px", height: "20px" }}
                    />
                </div>
            )}
            <label
                className={props.required ? 'required' : ''}
                htmlFor={props.id}>{props.label}</label>
        </>
    );
};

export default SelectItem;

